import React, { FC } from 'react';
import cn from 'classnames';
import BackButton from '../BackButton';
import ServicesList from '../ServicesList';
import st from './Services.module.css';

type ServicesProps = {
  subcategory: {
    id: number;
    name: string;
  };
  services: [
    {
      id: number;
      name: string;
      officesIds: [number];
    }
  ];
  office?: any;
  onSubcategoryReset: () => void;
  onClose: () => void;
};

const Services: FC<ServicesProps> = ({
  services,
  office = null,
  subcategory,
  onSubcategoryReset,
  onClose,
}) => (
  <div className={cn(st.services, 'scroll')}>
    <BackButton onClick={onSubcategoryReset} text={subcategory.name} />
    <ServicesList office={office} services={services} onClose={onClose} />
  </div>
);

export default Services;
